// Файл: src/components/NotificationPopover.js (ФИНАЛЬНАЯ ВЕРСИЯ)

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popover, List, ListItemText, Typography, Box, Button, ListItemButton, Divider } from '@mui/material';
import { formatDistanceToNow } from 'date-fns';
import { ru, enUS, mn } from 'date-fns/locale'; // Импортируем нужные локали

// Карта локалей для date-fns
const localeMap = {
  ru,
  en: enUS,
  mn,
};

export const NotificationPopover = ({
  anchorEl,
  open,
  onClose,
  notifications,
  onMarkAllAsRead,
  onClearAll,
  onNotificationClick
}) => {
  const { t, i18n } = useTranslation();
  const locale = localeMap[i18n.language] || ru; // По умолчанию русская

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          borderRadius: '8px',
        }
      }}
    >
      <Box sx={{ width: 380 }}>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" component="div">
            {t('notifications.title')}
          </Typography>
          <Button size="small" onClick={onMarkAllAsRead} sx={{ textTransform: 'none' }}>
            {t('notifications.mark_all_as_read')}
          </Button>
        </Box>
        <Divider />
        <List sx={{ p: 0, maxHeight: 400, overflowY: 'auto' }}>
          {notifications.length > 0 ? (
            notifications.map(notif => (
              <ListItemButton
                key={notif._id}
                alignItems="flex-start"
                sx={{
                  bgcolor: !notif.read ? 'action.hover' : 'transparent',
                  borderBottom: 1,
                  borderColor: 'divider'
                }}
                onClick={() => onNotificationClick(notif)}
              >
                <ListItemText
                  primaryTypographyProps={{
                    sx: {
                      fontWeight: !notif.read ? '600' : '400',
                      fontSize: '0.9rem',
                      whiteSpace: 'normal'
                    }
                  }}
                  secondaryTypographyProps={{ sx: { fontSize: '0.75rem', mt: 0.5 } }}
                  primary={notif.message}
                  secondary={formatDistanceToNow(new Date(notif.createdAt), { addSuffix: true, locale })}
                />
              </ListItemButton>
            ))
          ) : (
            <Typography sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
              {t('notifications.no_new')}
            </Typography>
          )}
        </List>
        {notifications.length > 0 && (
          <Box sx={{ p: 1, textAlign: 'center', borderTop: 1, borderColor: 'divider' }}>
            <Button size="small" color="error" onClick={onClearAll} sx={{ textTransform: 'none' }}>
              {t('notifications.clear_all')}
            </Button>
          </Box>
        )}
      </Box>
    </Popover>
  );
};